import { useState } from 'react';
import { LicenseAssignment } from '../components/LicenseAssignment';
import { InventoryPull } from '../components/InventoryPull';
import { DomainLookup } from '../components/DomainLookup';
import { OAuthApps } from '../components/OAuthApps';
import { MasterInboxForwarding } from '../components/MasterInboxForwarding';
import { ForeignDnsRuns } from '../components/ForeignDnsRuns';
import { DomainContests } from '../components/DomainContests';
import { SequencerConnect } from '../components/SequencerConnect';
import '../team/TeamShell.css';
import './TeamLeadShell.css';

type Tab =
  | 'inventory'
  | 'licensing'
  | 'lookup'
  | 'oauth'
  | 'master-inbox'
  | 'foreign-dns'
  | 'domain-contests'
  | 'sequencer';

interface TeamLeadShellProps {
  onSignOut: () => void;
}

export function TeamLeadShell({ onSignOut }: TeamLeadShellProps): JSX.Element {
  const [tab, setTab] = useState<Tab>('inventory');
  const [signingOut, setSigningOut] = useState(false);

  const handleSignOut = async (): Promise<void> => {
    setSigningOut(true);
    try {
      await fetch('/api/team-lead/logout', { method: 'POST' });
    } catch {
      // ignore — tearing down anyway
    } finally {
      onSignOut();
    }
  };

  return (
    <div className="team-shell">
      <header className="team-shell-header">
        <div className="team-shell-brand">
          <div className="team-shell-logo">AP</div>
          <div className="team-shell-titles">
            <span className="team-shell-product">Admin Panel</span>
            <span className="team-shell-context">Team Lead</span>
          </div>
        </div>
        <nav className="tl-tabs" aria-label="Team lead sections">
          <button
            type="button"
            className={`tl-tab ${tab === 'inventory' ? 'tl-tab--active' : ''}`}
            onClick={() => setTab('inventory')}
          >
            Inventory Pull
          </button>
          <button
            type="button"
            className={`tl-tab ${tab === 'licensing' ? 'tl-tab--active' : ''}`}
            onClick={() => setTab('licensing')}
          >
            Licensing
          </button>
          <button
            type="button"
            className={`tl-tab ${tab === 'lookup' ? 'tl-tab--active' : ''}`}
            onClick={() => setTab('lookup')}
          >
            Lookup
          </button>
          <button
            type="button"
            className={`tl-tab ${tab === 'oauth' ? 'tl-tab--active' : ''}`}
            onClick={() => setTab('oauth')}
          >
            OAuth Apps
          </button>
          <button
            type="button"
            className={`tl-tab ${tab === 'master-inbox' ? 'tl-tab--active' : ''}`}
            onClick={() => setTab('master-inbox')}
          >
            Master Inbox Forwarding
          </button>
          <button
            type="button"
            className={`tl-tab ${tab === 'foreign-dns' ? 'tl-tab--active' : ''}`}
            onClick={() => setTab('foreign-dns')}
          >
            Foreign CF DNS
          </button>
          <button
            type="button"
            className={`tl-tab ${tab === 'sequencer' ? 'tl-tab--active' : ''}`}
            onClick={() => setTab('sequencer')}
          >
            Sequencer Connect
          </button>
          <button
            type="button"
            className={`tl-tab ${tab === 'domain-contests' ? 'tl-tab--active' : ''}`}
            onClick={() => setTab('domain-contests')}
          >
            Domain Contests
          </button>
        </nav>
        <button
          type="button"
          className="team-shell-signout"
          onClick={() => void handleSignOut()}
          disabled={signingOut}
        >
          {signingOut ? 'Signing out…' : 'Sign out'}
        </button>
      </header>
      <main className="team-shell-main">
        {tab === 'inventory' && <InventoryPull />}
        {tab === 'licensing' && <LicenseAssignment />}
        {tab === 'lookup' && <DomainLookup />}
        {tab === 'oauth' && <OAuthApps />}
        {tab === 'master-inbox' && <MasterInboxForwarding />}
        {tab === 'foreign-dns' && <ForeignDnsRuns />}
        {tab === 'domain-contests' && <DomainContests />}
        {tab === 'sequencer' && <SequencerConnect />}
      </main>
    </div>
  );
}
